import { app, store } from "../index";
import { rtupdate, rtget } from "../actions/realtime-data";
import { getservice } from "./crudservice";
export const RealTimeFindRedux = (backendservice, param, value, reducer) => {
  let service = app.service(backendservice);
  service
    .find({ query: { [param]: value } })
    .then(data => store.dispatch(rtupdate(data, reducer)));
};
export const RealTimeGetRedux = (backendservice, id, reducer) => {
  let service = app.service(backendservice);
  console.log("getting test");
  service
    .get(id)
    .then(data => {
      getservice(backendservice, id).then(data1 =>
        store.dispatch(rtupdate(data1, reducer))
      );
    });
};
export const RealTimeFind = (backendservice, param, value, reducer) => {
  let service = app.service(backendservice);
  return service
    .find({ query: { [param]: value } })
    .then(data => {
      return data;
    });
};
export const RealTimeGet = (backendservice, id, reducer) => {
  let service = app.service(backendservice);
  return service
    .get(id)
    .then(data => {
      return data;
    });
};
export const realtimefindreduxobject = (backendservice, object, reducer) => {
  console.log("testing object");
  let service = app.service(backendservice);
  service.find({ query: object })
    .then(data => store.dispatch(rtupdate(data, reducer)));
};
export const RealTimeGrabRedux = (backendservice, reducer) => {
  let service = app.service(backendservice);
  service.find().then(data => store.dispatch(rtupdate(data, reducer)))
    // .then(data => store.dispatch(rtupdate(data, reducer)));

};
export const RealTimeGrab = backendservice => {
  let service = app.service(backendservice);
  return service
    .find()
    .then(data => {
      return data;
    });
};



// WEBPACK FOOTER //
// ./src/services/realtimeservice.js